<div class="right_col screen-height v_scrnss edit-page" role="main">
    <div class="container-fluid">
        <div class="row">
            <div class="col-sm-6 mb-4 ">
                <h1 class="text-left font-weight-bold text-uppercase text-dark">Affiliates / Referrers</h1>
            </div>
            <div class="col-sm-6 mb-4 text-right">
                <button class="btn btn-primary" style="margin-top: 15px;" (click)="openAddReferrerModal()">
                    + Add New Referrer
                </button>
            </div>
        </div>
        
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-body mt-4">
                        <table class="table row-border hover mat-table" width="100%" cellspacing="0" id="affiliates-table">
                            <thead>
                                <tr>
                                    <th class="th-heading">Name</th>
                                    <th class="th-heading">Email</th>
                                    <th class="th-heading">Referral Code</th>
                                    <th class="th-heading">Commission Rate</th>
                                    <th class="th-heading">Referrals</th>
                                    <th class="th-heading">Subscribers</th>
                                    <th class="th-heading">Revenue</th>
                                    <th class="th-heading">Amount Due</th>
                                    <th class="th-heading">Action</th>
                                </tr>
                            </thead>
                            <tbody *ngIf="affiliates?.length != 0">
                                <tr *ngFor="let aff of affiliates">
                                    <td>{{aff.name}}</td>
                                    <td>{{aff.email}}</td>
                                    <td><strong>{{aff.referralCode}}</strong></td>
                                    <td>{{aff.commissionRate}}%</td>
                                    <td>{{aff.totalReferredUsers}}</td>
                                    <td>{{aff.successfulSubscribers}}</td>
                                    <td>{{aff.eligibleRevenue | currency:'USD':'symbol'}}</td>
                                    <td class="text-danger font-weight-bold">{{aff.amountDue | currency:'USD':'symbol'}}</td>
                                    <td>
                                        <span class="flex_wrp flex_strt drec_colomn">
                                            <a> <button class="btn btn-outline-success user-glyf" (click)="payAffiliate(aff._id)">Mark Paid</button></a>
                                            <a> <button class="btn btn-outline-info user-glyf" (click)="viewStats(aff._id)">Stats</button></a>
                                        </span>
                                    </td>
                                </tr>
                            </tbody>
                            <tbody *ngIf="affiliates?.length == 0">
                                <tr>
                                    <td colspan="9" class="text-center no-data-available">No affiliates found.</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>

        <!-- Add Referrer Modal -->
        <div class="modal" tabindex="-1" role="dialog" [ngStyle]="{'display': displayModal ? 'block' : 'none'}" style="background-color: rgba(0,0,0,0.5);">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title font-weight-bold">Generate New Affiliate</h4>
                        <button type="button" class="close" (click)="closeModal()" aria-label="Close generate affiliate dialog">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <form>
                            <div class="form-group">
                                <label>Referrer Full Name</label>
                                <input type="text" class="form-control" name="name" [(ngModel)]="newReferrer.name" placeholder="e.g. Jane Doe">
                            </div>
                            <div class="form-group">
                                <label>User Email to Promote</label>
                                <input type="email" class="form-control" name="email" [(ngModel)]="newReferrer.email" placeholder="e.g. partner@example.com">
                            </div>
                            <div class="form-group">
                                <label>Custom Referral Code (Optional)</label>
                                <input type="text" class="form-control" name="code" [(ngModel)]="newReferrer.code" placeholder="e.g. AMARA2026">
                            </div>
                            <div class="form-group">
                                <label>Commission Rate (%)</label>
                                <input type="number" class="form-control" name="rate" [(ngModel)]="newReferrer.commissionRate" placeholder="e.g. 15">
                            </div>
                        </form>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" (click)="closeModal()">Cancel</button>
                        <button type="button" class="btn btn-primary" (click)="submitReferrer()">Generate Affiliate</button>
                    </div>
                </div>
            </div>
        </div>

        <!-- Stats Modal -->
        <div class="custom-modal-backdrop" *ngIf="statsModalVisible" (click)="closeStatsModal()"></div>
        <div class="custom-modal" *ngIf="statsModalVisible" role="dialog" aria-modal="true" aria-labelledby="affiliate-stats-title">
            <div class="custom-modal__header">
                <span class="custom-modal__icon">◌</span>
                <span class="custom-modal__title" id="affiliate-stats-title">{{ selectedAffiliate?.referralCode || 'Affiliate' }}</span>
            </div>

            <div class="custom-modal__profile">
                <div class="custom-modal__name">{{ selectedAffiliate?.name || 'Unknown Referrer' }}</div>
                <div class="custom-modal__email">{{ selectedAffiliate?.email || 'No email available' }}</div>
            </div>

            <div class="custom-modal__stats-grid">
                <div class="custom-modal__stat">
                    <span class="custom-modal__label">Referrals</span>
                    <strong>{{ selectedAffiliate?.totalReferredUsers || 0 }}</strong>
                </div>
                <div class="custom-modal__stat">
                    <span class="custom-modal__label">Subscribers</span>
                    <strong>{{ selectedAffiliate?.successfulSubscribers || 0 }}</strong>
                </div>
                <div class="custom-modal__stat">
                    <span class="custom-modal__label">Revenue</span>
                    <strong>{{ (selectedAffiliate?.eligibleRevenue || 0) | currency:'USD':'symbol' }}</strong>
                </div>
                <div class="custom-modal__stat custom-modal__stat--danger">
                    <span class="custom-modal__label">Amount Due</span>
                    <strong>{{ (selectedAffiliate?.amountDue || 0) | currency:'USD':'symbol' }}</strong>
                </div>
            </div>

            <div class="custom-modal__footer">
                <button type="button" class="custom-modal__button" (click)="closeStatsModal()">OK</button>
            </div>
        </div>

    </div>
</div>
